import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

interface ProjectTitleFieldProps {
  title: string;
  setTitle: (value: string) => void;
}

const ProjectTitleField: React.FC<ProjectTitleFieldProps> = ({ title, setTitle }) => {
  const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    // Limit to 60 characters (updated to match new limits)
    if (value.length <= 60) {
      setTitle(value);
    }
  };

  return (
    <div>
      <Label htmlFor="title">
        Project Goal <span className="text-red-500">*</span>
      </Label>
      <Input
        id="title"
        value={title}
        onChange={handleTitleChange}
        placeholder="Enter project goal"
        required
        maxLength={60}
      />
      <div className="text-xs text-gray-500 dark:text-gray-400 mt-1">
        {title.length}/60 characters
      </div>
    </div>
  );
};

export default ProjectTitleField;
